import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import AnimateHeight from 'react-animate-height';

import { withRtl } from '../hoc';
import style from './Accordion.scss';

class Accordion extends PureComponent {
  static defaultProps = {
    analytics: null,
    children: false,
    open: true,
    flipped: false,
    superLabel: false,
    isSummerRising: false,
  };
  static propTypes = {
    analytics: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    flipped: PropTypes.bool,
    label: PropTypes.string.isRequired,
    open: PropTypes.bool,
    superLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    isSummerRising: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      height: props.open ? 'auto' : 0,
    };
  }

  toggle = () => {
    const { open } = this.state;
    const { analytics, label, superLabel } = this.props;
    const analyticsText = superLabel ? `${superLabel} - ${label}` : label;
    // If this click opens the accordion push to GA
    if (!open && analytics) {
      analytics(analyticsText);
    }
    this.setState({
      ...this.state,
      open: !open,
      height: !open ? 'auto' : 0,
    });
  };

  render() {
    const { label, children, flipped, superLabel, isSummerRising, title } = this.props;
    const { height } = this.state;
    const superLabelContainer = superLabel ? style.superLabelContainer : null;
    const smallLabelClass = label === 'My Chances' ? style.smallLabel : null;
    let buttonClass = classNames(style.toggle, { [style.toggleFlipped]: flipped });
    if (isSummerRising) {
      buttonClass = classNames(style.summerRisingToggle, { [style.summerRisingToggleFlipped]: flipped });
    }

    return (
      <Fragment>
        <button aria-label={label} className={buttonClass} title={title} onClick={this.toggle} aria-expanded={this.state.open}>
          <div className={superLabelContainer}>
            {superLabel && <span className={style.superLabel}>{superLabel}</span>}
            <span className={smallLabelClass}>{label}</span>
          </div>
        </button>
        <AnimateHeight duration={300} height={height} style={{ width: '100%' }}>
          {children}
        </AnimateHeight>
      </Fragment>
    );
  }
}

export default withRtl(style)(withStyles(style)(Accordion));
